<script>

	const mixin = {
		methods: {
			getAsset: name => `${process.env.VUE_APP_API}/${name}`,
		}
	};

export default mixin;

</script>
